<template>
  <div class="churn-validation-action-popup-content">
    <div class="text">בשביל לאשר את התהליך של מחיקת כל הפרטים שלכם מהשירות יש לרשום את המילה ״מחיקה״ ואז לאשר את הפעולה.</div>
    <text-input class='text-input'
                :value="validationWord"
                :on-input="onInput"
                :error="!validationWordIsRight"
                :top-left-label="validationFailure"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseUI from 'base-ui';

export default {
  name: 'ChurnValidateActionPopupContent',
  components: {
    TextInput: BaseUI.TextInput,
  },
  data() {
    return {
      validationWord: '',
    };
  },
  computed: {
    ...mapState('churn', ['churnValidated']),
    validationWordIsRight() {
      return this.validationWord === 'מחיקה';
    },
    longValidationWordWasTyped() {
      return this.validationWord.length >= 5;
    },
    validationFailure() {
      return !this.validationWordIsRight && this.longValidationWordWasTyped ? 'כדאי לבדוק אם הקלדתם נכון' : null;
    },
  },
  methods: {
    ...mapActions('churn', ['setChurnValidated']),
    async onInput(value) {
      this.validationWord = value;
      await this.setChurnValidated(this.validationWordIsRight);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  .churn-validation-action-popup-content {
    .text {
      font-size: 16px;
      font-family: SimplerPro;
      line-height: 1.5;
      margin-bottom: 21px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/churn/ChurnValidateActionPopupContent.vue